export const CLERK_PUBLISHABLE_KEY =
  (import.meta.env?.VITE_CLERK_PUBLISHABLE_KEY as string | undefined)?.trim() ?? '';

export const ACCOUNT_SYNC_ENABLED =
  CLERK_PUBLISHABLE_KEY.length > 0 &&
  !CLERK_PUBLISHABLE_KEY.includes('REPLACE_WITH');
